// Software brand (İŞ İŞLEM). Not the businesses' own print logos.
export function BrandMark({ size = 44, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" className={className} aria-hidden="true">
      <rect x="15" y="30" width="7" height="16" rx="2.5" fill="#3B82F6" />
      <rect x="26" y="20" width="7" height="26" rx="2.5" fill="#60A5FA" />
      <rect x="37" y="9" width="7" height="37" rx="2.5" fill="#93C5FD" />
      <path d="M7 34 A25 25 0 0 0 55 42" fill="none" stroke="#F59E0B" strokeWidth="6" strokeLinecap="round" />
      <path d="M55 42 A25 25 0 0 0 57 30" fill="none" stroke="#2563EB" strokeWidth="6" strokeLinecap="round" />
    </svg>
  );
}

// tone="light": white text (dark background); tone="dark": navy text (light background)
export function BrandLogo({ tone = "light", size = 44, className = "" }) {
  const main = tone === "light" ? "#FFFFFF" : "#0F2A5C";
  const sub = tone === "light" ? "#BFD3F5" : "#475569";
  return (
    <div className={`flex items-center gap-2.5 select-none ${className}`} data-testid="brand-logo">
      <BrandMark size={size} />
      <div className="leading-none">
        <div className="font-head font-extrabold tracking-tight" style={{ color: main, fontSize: size * 0.58 }}>İŞ İŞLEM</div>
        <div className="font-head font-medium mt-1" style={{ color: sub, fontSize: size * 0.24, letterSpacing: "0.28em" }}>ÖN MUHASEBE</div>
      </div>
    </div>
  );
}
